// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"816cb2f4","981":"8b0166a0"}[chunkId] + ".chunk.js";
};